import { render } from "./CommonFileUploadTable.vue?vue&type=template&id=ade17e50"
import script from "./CommonFileUploadTable.vue?vue&type=script&lang=js"
export * from "./CommonFileUploadTable.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__